import { render, staticRenderFns } from "./AdminImportExport.vue?vue&type=template&id=6ab88c81&"
import script from "./AdminImportExport.vue?vue&type=script&lang=js&"
export * from "./AdminImportExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports